var moduleMap = {
	"./store": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_reduxjs_toolkit_reduxjs_toolkit"), __webpack_require__.e("src_client_store_index_ts")]).then(() => (() => ((__webpack_require__(/*! ./src/client/store */ "./src/client/store/index.ts")))));
	},
	"./i18n": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_i18next-http-backend_esm_index_js-node_modules_i18next_dist_esm_i18next_-577ac6"), __webpack_require__.e("webpack_sharing_consume_default_core-ui_components_core-ui_components"), __webpack_require__.e("src_client_app_i18n_i18n_ts")]).then(() => (() => ((__webpack_require__(/*! ./src/client/app/i18n/i18n.ts */ "./src/client/app/i18n/i18n.ts")))));
	},
	"./i18nStore": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_core-ui_components_core-ui_components"), __webpack_require__.e("src_client_app_i18n_i18nStore_ts")]).then(() => (() => ((__webpack_require__(/*! ./src/client/app/i18n/i18nStore.ts */ "./src/client/app/i18n/i18nStore.ts")))));
	},
	"./useApi": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_axios_lib_axios_js"), __webpack_require__.e("webpack_sharing_consume_default_core-ui_components_core-ui_components"), __webpack_require__.e("src_client_app_hooks_useApi_ts")]).then(() => (() => ((__webpack_require__(/*! ./src/client/app/hooks/useApi.ts */ "./src/client/app/hooks/useApi.ts")))));
	},
	"./nodeStore": () => {
		return __webpack_require__.e("src_client_app_stores_nodeStore_ts").then(() => (() => ((__webpack_require__(/*! ./src/client/app/stores/nodeStore.ts */ "./src/client/app/stores/nodeStore.ts")))));
	},
	"./platformStore": () => {
		return __webpack_require__.e("src_client_app_stores_platformStore_ts").then(() => (() => ((__webpack_require__(/*! ./src/client/app/stores/platformStore.ts */ "./src/client/app/stores/platformStore.ts")))));
	},
	"./authStore": () => {
		return __webpack_require__.e("src_client_app_stores_authStore_ts").then(() => (() => ((__webpack_require__(/*! ./src/client/app/stores/authStore.ts */ "./src/client/app/stores/authStore.ts")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});